module.exports = __webpack_public_path__ + "img/banner.fc565a69.png";